export class Playback {
    constructor(dataUrl, loop = false) {
        this.audio = new Audio(dataUrl);
        this.audio.onerror = event => console.log(`Error while playback, event: ${JSON.stringify(event)}`);
        if (loop) {
            this.audio.onended = () => this.startFromBeginning();
        }
    }
    preload() {
        this.audio.load();
        return new Promise((resolve, reject) => {
            this.audio.addEventListener('canplaythrough', () => resolve());
        });
    }
    async startFromBeginning() {
        this.stop();
        await this.audio.play();
    }
    stop() {
        this.audio.pause();
        this.audio.currentTime = 0;
    }
    mute() {
        this.audio.muted = true;
    }
    unmute() {
        this.audio.muted = false;
    }
}
